<div class="selector-container">
    <mat-select
        placeholder="Make"
        [(ngModel)]="selectedMake"
        (ngModelChange)="onChange()"
        hideSingleSelectionIndicator
    >
        <mat-option>--</mat-option>
        @for (make of dataMake; track make) {
            <mat-option [value]="make">
                {{ make }}
            </mat-option>
        }
    </mat-select>

    @if (!selectedMake && !selectedModel && isLoading | async) {
        <mat-label>
            <div class="select-placeholder-container">
                <span>Loading...</span>
                <mat-spinner class="spinner" diameter="20"></mat-spinner>
            </div>
        </mat-label>
    }
</div>

<div class="selector-container">
    <mat-select
        placeholder="Model"
        [(ngModel)]="selectedModel"
        (ngModelChange)="onChange()"
        [disabled]="!selectedMake"
        hideSingleSelectionIndicator
    >
        <mat-option>--</mat-option>
        @for (model of dataModel; track model) {
            <mat-option [value]="model">
                {{ model }}
            </mat-option>
        }
    </mat-select>

    @if (!selectedModel && selectedMake && isLoading | async) {
        <mat-label>
            <div class="select-placeholder-container">
                <span>Loading...</span>
                <mat-spinner class="spinner" diameter="20"></mat-spinner>
            </div>
        </mat-label>
    }
</div>
